export const SortService = {
  limitOptions: [
    {label: '30', value: '30'},
    {label: '50', value: '50'},
    {label: '70', value: '70'},
    {label: '100', value: '100'},
  ],
};
